// extracted by mini-css-extract-plugin
export default {"text":"tooltip_text__w5Zj7","onlyOnLaptop":"tooltip_onlyOnLaptop__Qic4a"};